(() => {
  function initialize(root = document) {
    const dialog = document.querySelector('[data-cf-image-dialog]');
    root.querySelectorAll('[data-cf-lightbox]').forEach(link => {
      if (link.dataset.cfLightboxReady || !dialog) return;
      link.dataset.cfLightboxReady = 'true';
      link.addEventListener('click', event => {
        event.preventDefault();
        const image = dialog.querySelector('img');
        image.src = link.href;
        image.alt = link.getAttribute('aria-label') || link.querySelector('img')?.alt || '';
        dialog.querySelector('p').textContent = image.alt;
        dialog.showModal();
      });
    });
    if (dialog && !dialog.dataset.cfReady) {
      dialog.dataset.cfReady = 'true';
      dialog.querySelector('[data-cf-image-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => dialog.querySelector('img').removeAttribute('src'));
      dialog.addEventListener('click', event => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); } });
    }
    root.querySelectorAll('[data-cf-gallery]').forEach(gallery => {
      if (gallery.dataset.cfReady) return;
      gallery.dataset.cfReady = 'true';
      gallery.querySelectorAll('[data-cf-thumb]').forEach(thumb => {
        thumb.addEventListener('click', event => {
          event.preventDefault();
          const image = gallery.querySelector('.cf-main-image');
          if (!image) return;
          image.srcset = [360, 480, 640, 720, 900, 1200].map(width => { const url = new URL(thumb.dataset.full, location.href); url.searchParams.set('width', width); return `${url.href} ${width}w`; }).join(', ');
          image.src = thumb.dataset.full;
          gallery.querySelector('[data-cf-zoom]').href = thumb.dataset.zoom;
          gallery.querySelectorAll('[data-cf-thumb]').forEach(item => item.setAttribute('aria-current', String(item === thumb)));
        });
      });
    });
    root.querySelectorAll('[data-cf-reviews]').forEach(widget => {
      if (widget.dataset.cfReady) return;
      widget.dataset.cfReady = 'true';
      const track = widget.querySelector('[data-cf-review-track]');
      const pause = widget.querySelector('[data-cf-review-pause]');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let paused = reduced.matches;
      let hovering = false;
      const updatePause = () => {
        pause.textContent = paused ? '▶' : 'Ⅱ';
        pause.setAttribute('aria-label', paused ? pause.dataset.playLabel : pause.dataset.pauseLabel);
      };
      const move = direction => {
        const cards = [...track.children];
        if (!cards.length) return;
        const index = Math.round(track.scrollLeft / (cards[0].offsetWidth + 14));
        const next = (index + direction + cards.length) % cards.length;
        track.scrollTo({left: next * (cards[0].offsetWidth + 14), behavior: reduced.matches ? 'instant' : 'smooth'});
      };
      widget.querySelector('[data-cf-review-prev]').addEventListener('click', () => move(-1));
      widget.querySelector('[data-cf-review-next]').addEventListener('click', () => move(1));
      pause.addEventListener('click', () => { paused = !paused; updatePause(); });
      widget.addEventListener('mouseenter', () => { hovering = true; });
      widget.addEventListener('mouseleave', () => { hovering = false; });
      track.addEventListener('pointerdown', () => { paused = true; updatePause(); });
      updatePause();
      const timer = setInterval(() => {
        if (!widget.isConnected) { clearInterval(timer); return; }
        if (!paused && !hovering && !document.hidden && !widget.contains(document.activeElement)) move(1);
      }, 3500);
    });
    root.querySelectorAll('[data-cf-main-purchase]').forEach(purchase => {
      if (purchase.dataset.cfReady || !('IntersectionObserver' in window)) return;
      purchase.dataset.cfReady = 'true';
      const sticky = purchase.closest('.cf-hero').querySelector('[data-cf-sticky]');
      const closing = document.querySelector('.cf-closing');
      let purchasePassed = false;
      let closingVisible = false;
      const update = () => { sticky.hidden = !purchasePassed || closingVisible; };
      new IntersectionObserver(entries => {
        purchasePassed = !entries[0].isIntersecting && entries[0].boundingClientRect.bottom < 0;
        update();
      }, {threshold: 0}).observe(purchase);
      if (closing) new IntersectionObserver(entries => {
        closingVisible = entries[0].isIntersecting;
        update();
      }).observe(closing);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

